import { createBrowserHistory } from "history";
import AudioService from "services/audio.service";
import AuthService from "services/auth.service";
import useChannel from "hooks/useChannel";
import { reportUnauthorized } from "services/cable";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "app/notificationSlice";
import { fetchUnreads } from "app/teleconsultSlice";
import BookdocIcon from "assets/icons/BookdocIcon.svg";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const mainSources = ['Appointment','ChatMessageNotification','ChatSession'];
const assistantSources = ['Appointment','e-prescription'];
const doctorSources = ['teleconsult__new_chat_session','teleconsult__new_chat_message','e-prescription'];

const CustomToast = ({ title, text }) => (
  <div className="toast-container">
    <Link to="/eb/prescriptions" className="stretched-link"></Link>
    <img src={BookdocIcon} alt="bookdoc-logo" />
    <div className="content">
      <p className="title">{title}</p>
      <p className="description">{text}</p>
    </div>
  </div>
);

export function NotificationSocket() {
  const dispatch = useDispatch();
  const { isClinic, isAssistant, chanelId } = AuthService.getSocketInfo();

  // Doctors are identified by the JWT in the connect URL. Assistants must name
  // the clinic or the doctor they are acting for.
  let channelParams = { channel: "NotificationsChannel" };
  if (isAssistant) {
    channelParams = !chanelId
      ? null
      : isClinic
      ? { channel: "NotificationsChannel", clinic_id: chanelId }
      : { channel: "NotificationsChannel", doctor_id: chanelId };
  }

  const UpdateNotifications = () => {
    if(['/eb/notifications', '/notifications'].indexOf(createBrowserHistory().location.pathname) > -1){
      dispatch(fetchNotifications(1))
    }
  };

  useChannel(channelParams, {
    connected: () => {
      UpdateNotifications();
      if (!isAssistant) dispatch(fetchUnreads());
    },

    rejected: () => {
      if (!isAssistant) reportUnauthorized("cable notifications subscription rejected");
    },

    received: (data) => {
      // Payload is a plain object now — it used to arrive as a JSON string.
      var canNotify;
      var source = data?.source;
      var payload = data?.payload;
      var practiceLocation = AuthService.getPracticeLocation();

      if(isAssistant){
        canNotify = payload && (assistantSources.includes(source) || assistantSources.includes(payload?.type));
      }else{
        canNotify = payload && (doctorSources.includes(payload?.type) || mainSources.includes(source));
      }

      // [NOTE] To notify user with notification sound
      if(canNotify){
        if(payload?.type === 'e-prescription' || source !== 'Appointment' ||
        (source === 'Appointment' && payload?.appointment_type === 'virtual') ||
        (source === 'Appointment' && payload?.appointment_type === 'physical' && payload?.location === practiceLocation?.name)){
          AudioService.notification();
          UpdateNotifications();
        }

        if (payload?.type === "e-prescription" && payload?.title) {
          toast(
            <CustomToast
              title={payload?.title}
              text={data?.message}
            />,
            {
              autoClose: 300000,
              className: "notification-toast",
              hideProgressBar: true,
            }
          );
        }
      }

      // [NOTE] To update the teleconsult notification badge number
      if(!isAssistant && (doctorSources.includes(payload?.type) || mainSources.includes(source))){
        dispatch(fetchUnreads());
      }
    },
  });

  return null;
}

export default NotificationSocket;
